// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"a9daea64","614":"cba2f32a","832":"a9daea64"}[chunkId] + ".chunk.css";
};